import { render, staticRenderFns } from "./documenttypeTax.vue?vue&type=template&id=06402210"
import script from "./documenttypeTax.vue?vue&type=script&lang=js"
export * from "./documenttypeTax.vue?vue&type=script&lang=js"
import style0 from "./documenttypeTax.vue?vue&type=style&index=0&id=06402210&prod&lang=css"
import style1 from "./documenttypeTax.vue?vue&type=style&index=1&id=06402210&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports